import React from 'react'
import { FaCheck, FaTimes } from 'react-icons/fa'
import UserCard from './UserCard'

const RequestsTab = ({ friendRequests, sentRequests, onAccept, onDecline, loading }) => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-white mb-6">Friend Requests</h2>

      {/* Pending Requests */}
      <div className="mb-8">
        <h3 className="text-xl font-medium text-white mb-4">Received Requests ({friendRequests.length})</h3>
        <div className="space-y-4">
          {friendRequests.map((request) => (
            <UserCard
              key={request._id}
              user={request.requester}
              subtitle={request.message ? `"${request.message}"` : null}
              actions={
                <>
                  <button
                    onClick={() => onAccept(request._id)}
                    disabled={loading}
                    className="bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg text-sm sm:text-base font-medium transition-colors flex items-center gap-1 sm:gap-2"
                  >
                    <FaCheck className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span className="hidden sm:inline">Accept</span>
                    <span className="sm:hidden">✓</span>
                  </button>
                  <button
                    onClick={() => onDecline(request._id)}
                    disabled={loading}
                    className="bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg text-sm sm:text-base font-medium transition-colors flex items-center gap-1 sm:gap-2"
                  >
                    <FaTimes className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span className="hidden sm:inline">Decline</span>
                    <span className="sm:hidden">×</span>
                  </button>
                </>
              }
            />
          ))}

          {friendRequests.length === 0 && (
            <div className="text-center py-8">
              <p className="text-gray-400">No pending friend requests</p>
            </div>
          )}
        </div>
      </div>

      {/* Sent Requests */}
      <div>
        <h3 className="text-xl font-medium text-white mb-4">Sent Requests ({sentRequests.length})</h3>
        <div className="space-y-4">
          {sentRequests.map((request) => (
            <UserCard
              key={request._id}
              user={request.recipient}
              actions={<span className="text-yellow-400 font-medium">⏳ Pending</span>}
            />
          ))}

          {sentRequests.length === 0 && (
            <div className="text-center py-8">
              <p className="text-gray-400">No sent requests</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RequestsTab